import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const InfoImage = styled(Box)(({ theme }) => ({
  width: '100%',
  borderRadius: theme.shape.rounded.xl,
  overflow: 'hidden',
  height: 'fit-content',

  [theme.breakpoints.up('lg')]: {
    marginTop: '3.25rem',
    flex: 1,
  },
}));
